import defaultImage from '@/assets/images/restaurant.png'

function parseDeliveryMinutes(value) {
  if (value == null || value === '') {
    return null
  }
  const num = Number(value)
  return Number.isFinite(num) ? Math.floor(num) : null
}

function formatDeliveryTimeShort(raw) {
  const min = parseDeliveryMinutes(raw.delivery_time_min)
  const max = parseDeliveryMinutes(raw.delivery_time_max)

  if (min != null) {
    return `${min} мин`
  }
  if (max != null) {
    return `${max} мин`
  }
  return ''
}

function formatDeliveryTimeRange(raw) {
  const min = parseDeliveryMinutes(raw.delivery_time_min)
  const max = parseDeliveryMinutes(raw.delivery_time_max)

  if (min != null && max != null) {
    if (min === max) {
      return `${min} мин`
    }
    return `${min}–${max} мин`
  }
  if (min != null) {
    return `от ${min} мин`
  }
  if (max != null) {
    return `до ${max} мин`
  }
  return ''
}

function parseHour(value) {
  if (value == null || value === '') {
    return null
  }
  const num = Number(value)
  return Number.isFinite(num) ? num : null
}

export function normalizeRestaurantAdminStatus(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase() === 'blocked'
    ? 'blocked'
    : 'active'
}

export function mapRestaurant(raw) {
  const cuisineType =
    raw.cuisine_type != null && raw.cuisine_type !== '' ? String(raw.cuisine_type) : ''

  return {
    id: String(raw.id ?? ''),
    userId: (() => {
      const id = raw.user_id ?? raw.userId
      return id != null && String(id).trim() ? String(id).trim() : ''
    })(),
    ledgerId: (() => {
      const id = raw.ledger_id ?? raw.ledgerId
      return id != null && String(id).trim() ? String(id).trim() : ''
    })(),
    title: String(raw.title ?? ''),
    cuisineType,
    categoryId: cuisineType || 'all',
    deliveryTimeShort: formatDeliveryTimeShort(raw),
    deliveryTime: formatDeliveryTimeRange(raw),
    deliveryTimeMin: parseDeliveryMinutes(raw.delivery_time_min),
    deliveryTimeMax: parseDeliveryMinutes(raw.delivery_time_max),
    opensAt: parseHour(raw.opens_at),
    closesAt: parseHour(raw.closes_at),
    isOpen: Boolean(raw.is_open ?? false),
    rating: Number.isFinite(Number(raw.rating)) ? Number(raw.rating) : 0,
    reviewsCount: Number.isFinite(Number(raw.reviews_count)) ? Number(raw.reviews_count) : 0,
    imageUrl:
      typeof raw.image_url === 'string' && raw.image_url ? raw.image_url : defaultImage,
    address:
      typeof raw.address === 'string' && raw.address.trim() ? raw.address.trim() : '',
    location: raw.location ?? null,
    status: normalizeRestaurantAdminStatus(raw.status),
    isActive: raw.is_active !== false,
    isFavorite: raw.is_favorite === true,
    sort: Number.isFinite(Number(raw.sort)) ? Math.max(0, Math.floor(Number(raw.sort))) : 0,
    tags: Array.isArray(raw.tags) ? raw.tags.map((tag) => String(tag)) : [],
    commissionRate: (() => {
      const rate = Number(raw.commission_rate)
      return Number.isFinite(rate) ? rate : null
    })(),
    telegramChatId:
      raw.telegram_chat_id != null && raw.telegram_chat_id !== ''
        ? String(raw.telegram_chat_id)
        : '',
    supportTelegramUrl:
      typeof raw.support_telegram_url === 'string' ? raw.support_telegram_url.trim() : '',
  }
}
